export default "__VITE_ASSET__DilJx5br__"